import { Procedure } from 'presentation/doctor/pages/Patient'
import { AnesthetistType } from './types'

export function getMainProcedureName(procedures: Procedure[]) {
  return procedures?.filter((procedure) => procedure.isMain)[0].description
}

export const getTechnique = (techninc: string) => {
  switch (techninc.toLocaleLowerCase()) {
    case 'conventional' || 'convencional':
      return 'Convencional'
    case 'video':
      return 'Vídeo'
    case 'robotic' || 'robótica':
      return 'Robótica'
    case 'makoRobot' || 'robô mako':
      return 'Robô Mako'
    case 'rosaRobot' || 'robô rosa':
      return 'Robô Rosa'
    case 'laser':
      return 'Laser'
  }
}

export function getAnesthetistType(anesthetist: any) {
  if (anesthetist.type === AnesthetistType.CHOOSE_ANESTHESTIST) {
    return {
      title: 'Anestesista de preferência:',
      data: anesthetist.name
    }
  }

  if (anesthetist.type === AnesthetistType.LOCAL) {
    return { title: 'Anestesia:', data: 'Local' }
  }

  if (anesthetist.type === AnesthetistType.SCALE) {
    return { title: 'Anestesia:', data: 'Escala' }
  }
}
